module.exports = __webpack_public_path__ + "static/media/Certifications.ae396ed1.png";